import React, { useState} from 'react';
import { useTranslation } from "react-i18next";
import { Button } from 'primereact/button';
import PumpsInput from './pumpsInput';
import PumpsOutput from './pumpsOutput';
import { useSelector } from 'react-redux';

const PumpeHome = () => {
  const { t } = useTranslation();

    const [changeView, setChangeView] = useState(1);
    const activeClass = 'activeButton'
    const [bonitetData, setBonitetData] = useState(null);
    const company = useSelector(state => state.company)

return (
    <div>
        <Button id={changeView == 1 && activeClass} label={t('magacin.ulaz')} style={{fontSize: 'smaller', marginTop:'1%', marginLeft:'1%'}}  className="mt-3" onClick={()=> {setChangeView(1)} } />
        <Button id={changeView == 2 && activeClass} label={t('magacin.izlaz')} style={{fontSize: 'smaller', marginTop:'1%', marginLeft:'1%'}}  className="mt-3" onClick={()=> {setChangeView(2)} } />
    
        {changeView == 1 && <PumpsInput changeView={changeView}/>}
        {changeView == 2 && <PumpsOutput changeView={changeView}/>}
    </div>
)
}

export default PumpeHome;